import React, { Suspense } from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const withLoader = (Component) => {
  return (props) => (
    <Suspense
      fallback={
        <div
          style={{
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
          }}
        >
          <Spin
            spinning={true}
            indicator={<LoadingOutlined style={{ fontSize: 36 }} spin />}
          />
        </div>
      }
    >
      <Component style={{ minHeight: 100 }} {...props} />
    </Suspense>
  );
};

export default withLoader;
